import { IStyle } from '@fluentui/react';
import { IH2OTheme, Sizes } from '@h2oai/ui-kit';

export interface IRecentlyOpenedFeatureSetListStyles {
  root?: IStyle;
  list?: IStyle;
}

export interface IRecentlyOpenedFeatureSetListClassNames {
  root: string;
  list: string;
}

export const recentlyOpenedFeatureSetListStylesDefault = (
  theme: IH2OTheme
): Partial<IRecentlyOpenedFeatureSetListStyles> => ({
  root: {
    height: '100%',
    backgroundColor: theme.semanticColors?.contentBackground,
    padding: '8px 16px 0px 16px',
    borderRadius: Sizes.borderRadius,
  },
  list: {
    height: '100%',
    overflow: 'auto',
  },
});
